require("!!/var/www/melochenator_prod/frontend/node_modules/script-loader/addScript.js")(require("!!/var/www/melochenator_prod/frontend/node_modules/raw-loader/index.js!/var/www/melochenator_prod/frontend/node_modules/jquery-serializejson/jquery.serializejson.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-serializejson/jquery.serializejson.js
// module id = 906
// module chunks = 12